import {all, call, put, takeEvery} from "redux-saga/effects";
import actions from './actions';
import {jsforceResponse} from "@/config/httpService";
import {api} from "@redux/api";

export function* getGasData() {
    let result = yield call(api.getGas);
    result = jsforceResponse(result, '', false, true)
    console.log('result', result.data.results)
    if (result.status === 200) {
        yield put(actions.GasSuccess(result.data.results));
    }

}


export function* watchGetGas() {
    yield takeEvery(actions.Gas_REQUEST, getGasData);
}

export default function* GasSage() {
    yield all(
        [
            watchGetGas()
        ]
    )
}
